export const newVersionOfConvertModelToInputs = async (data = {}) => {

    const { model, sectionLabel, submitText, submissionFunctionDetails, withSubmitButton, withFullContainerDiv, instructionTitle, instructionSubtitle, doNotShowInstruction, onBackBtnClicked, showBackBtn } = data;

    let { predefinedFunction, addToSubmissionData, functionPath, functionParameters } = submissionFunctionDetails || {};

    const generateId = (await import(/* webpackPrefetch: true */ "./generateId.js")).generateId;
    const setTxtV2 = (await import(/* webpackPrefetch: true */ "./setTxtV2.js")).setTxtV2;
    const getBackBtnToUseOnSlideShow = (await import(/* webpackPrefetch: true */ "../../functions/get/getBackBtnToUseOnSlideShow.js")).getBackBtnToUseOnSlideShow;

    const sectionLabelText = setTxtV2({
        attributes: {},
        txt: sectionLabel,
        type: "html"
    });

    const getInputFromModelDetails = (await import(/* webpackPrefetch: true */ "./getInputFromModelDetails.js")).getInputFromModelDetails;

    const modelId = generateId();

    const sectionTitle = `
		<div class="smetio-input-section-title smetio-input-section-title-${modelId}"> 
			<h5 class=""> ${sectionLabelText} </h5>	 

			<div> 
				<i class="smetio-icon smetio-icon-angle-down"></i> 
			</div>
			
		</div>
	`;

    let output = "";

    for (let key in model) {

        const input = model[key].isAsection === true ? await newVersionOfConvertModelToInputs({ model: model[key]["model"], sectionLabel: model[key]["label"] }) : await getInputFromModelDetails({ model, key, modelId });

        if (input === false) continue;

        output += input;

    };


    const sectionContent = `
		<div data-smetio-is-visible="no" class="smetio-input-section-content smetio-input-section-content-${modelId}">
			${output}
		</div>
	`;

    output = sectionLabel ? sectionContent : output;

    output = sectionLabel ? `<div class="smetio-input-section"> ${sectionTitle} ${output} </div>` : output;


    if (sectionLabel) {
        $("body").on("mousedown", `.smetio-input-section-title-${modelId}`, (event) => {

            const isVisible = $(`.smetio-input-section-content-${modelId}`).attr("data-smetio-is-visible");

            if (isVisible === "no") {
                $(`.smetio-input-section-content-${modelId}`).attr("data-smetio-is-visible", "yes");
                return $(`.smetio-input-section-title-${modelId} div`).html(" <i class=\"smetio-icon smetio-icon-angle-up\"></i>");

            };

            $(`.smetio-input-section-content-${modelId}`).attr("data-smetio-is-visible", "no");
            return $(`.smetio-input-section-title-${modelId} div`).html(" <i class=\"smetio-icon smetio-icon-angle-down\"></i>");

        });
    };

    if(!withSubmitButton && !withFullContainerDiv) return output;

    const submitBtnText = setTxtV2({ attributes: {}, txt: submitText || "txt299", type: "html"});	

    let submitBtn = `
		<div class="smetio-input-submit-btn-container smetio-input-submit-btn-container-${modelId}"> 
			<button class="smetio-input-submit-btn smetio-input-submit-btn-${modelId}">
				${submitBtnText} 
			</button>
		</div>	
	`;
    if(!withSubmitButton ) submitBtn = "";

    let instructionTitleText = setTxtV2({ attributes: {}, txt: instructionTitle, type: "html"});	
    const instructionSubtitleText = doNotShowInstruction === true ? "" : setTxtV2({ attributes: {}, txt: instructionSubtitle || "txt56", type: "html"});	

    instructionTitleText = instructionTitleText ? `<h4 class="smetio-h4-text-size smetio-input-instruction-title"> ${instructionTitleText} </h4>` : "";

    const backBtn = showBackBtn === true ? await getBackBtnToUseOnSlideShow({showText:true, showIcon:true}) : "";
	

    output = `

		<div class="smetio-whole-input-form-container"> 

			<div style="padding-left:5px; width:auto;" class="smetio-accent-dominant-hover smetio-whole-input-form-container-back-btn smetio-whole-input-form-container-back-btn${modelId}" > 
				${backBtn} 
			</div>

			${instructionTitleText}
			<div class="smetio-input-instruction-subtitle"> <p class="smetio-p-text-size"> ${ instructionSubtitleText} </p> </div>

			${output}
			${submitBtn}

		</div>
	`;

    if(!withSubmitButton ) return output;

    $("body").on("mousedown", `.smetio-whole-input-form-container-back-btn${modelId}`, async (event) => {
        if(onBackBtnClicked) return onBackBtnClicked();
    });


    $("body").on("mousedown", `.smetio-input-submit-btn-${modelId}`, async (event) => {


        const getPureModelFromModelWithSection = (await import(/* webpackPrefetch: true */ "@schaniag/private")).getPureModelFromModelWithSection;

        const submissionData = { formData: {}, ...addToSubmissionData };
        const pureModel = getPureModelFromModelWithSection(model);


        for (const key in pureModel) {

            const isValidated = await pureModel[key].inputClass.valueHasChanged();
            let errorMessage = setTxtV2({ attributes: {}, txt: "txt300", type: "html"});
            errorMessage +=` - ${key}`;

            if (!isValidated) return window.smetioVisitor.showNotification({ type:"danger", body: [{ message: errorMessage}] });

            const value = pureModel[key].inputClass.getValue();

            submissionData.formData[key] = value;
        };

        if (!submissionFunctionDetails) return false;
        

        if(!functionParameters) functionParameters = {};
        functionParameters.submissionData = submissionData;

        if(typeof predefinedFunction === "function") return predefinedFunction(functionParameters);

        const functionName = functionPath.split("/").pop();
        const func = await import(/* webpackPrefetch: true */ `../../functions/${functionPath}.js`);

        if (func[functionName]) func[functionName](functionParameters);

    });

    return output;


};